module.exports = __webpack_public_path__ + "static/media/Watchog_gaussian2.0080fb4a.png";